import React from 'react';
import { GoogleMap, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';
import styles from './googleMapStyle.json';
import markerIcon from './marker.png';

const googleMapsDefaultOptions = {
    disableDefaultUI: true, // disable default map UI
    draggable: true, // make map draggable
    keyboardShortcuts: false, // disable keyboard shortcuts
    scaleControl: false, // allow scale controle
    scrollwheel: true, // allow scroll wheel
    styles: styles
};

export const Map = withScriptjs(withGoogleMap(({centerCoordinates, children}) =>(
    <GoogleMap
        defaultOptions={googleMapsDefaultOptions}
        defaultZoom={17}
        defaultCenter={centerCoordinates}>
        {children}
    </GoogleMap>
)));

export const MapMarker = ({position})=> (
    <Marker 
        icon={ {
            url: markerIcon,
            scaledSize: new window.google.maps.Size(80, 80)
        } }
        position={position}/>
);